import {
  SHOWCASE_DESIGN_PARTS,
  type ShowcaseDesignProgressStage,
} from "../../../lib/showcaseDesignContract";

type Props = {
  completed: number;
  total: number;
  startText: string;
  middleText: string;
  finalText: string;
};

export function ProgressBar({
  completed,
  total,
  startText,
  middleText,
  finalText,
}: Props) {
  const ratio = total === 0 ? 0 : completed / total;
  const percent = Math.round(Math.min(Math.max(ratio, 0), 1) * 100);
  const stage = progressStage(percent);
  const text = progressHint(stage, startText, middleText, finalText);

  return (
    <div
      className="tp-showcase-progress"
      data-tp-part={SHOWCASE_DESIGN_PARTS.progress}
      data-completed={completed}
      data-total={total}
      data-percent={percent}
      data-stage={stage}
    >
      <div
        key={text}
        className="tp-showcase-progress-hint"
        data-tp-part={SHOWCASE_DESIGN_PARTS.progressHint}
      >
        {text}
      </div>
      <div
        className="tp-showcase-progress-track"
        data-tp-part={SHOWCASE_DESIGN_PARTS.progressTrack}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div
          className="tp-showcase-progress-fill"
          data-tp-part={SHOWCASE_DESIGN_PARTS.progressFill}
          style={{ width: `${percent}%` }}
        />
        <div
          className="tp-showcase-progress-percent"
          data-tp-part={SHOWCASE_DESIGN_PARTS.progressPercent}
        >
          {percent}%
        </div>
      </div>
    </div>
  );
}

function progressHint(
  stage: ShowcaseDesignProgressStage,
  startText: string,
  middleText: string,
  finalText: string,
): string {
  if (stage === "final") return finalText;
  if (stage === "middle") return middleText;
  return startText;
}

function progressStage(percent: number): ShowcaseDesignProgressStage {
  if (percent >= 90) return "final";
  if (percent >= 50) return "middle";
  return "start";
}
